export default function isValidTagId(tagId: number, options: number[]): boolean {
  return options.includes(tagId);
}
